module.exports = __webpack_public_path__ + "userCenter-achievement-icon3-bfaa114c.png";